import { useCallback } from 'react';
import { useMutation, gql } from '@apollo/react-hooks';
import { get, pick } from 'lodash';
import type { CreateLocationMutation, Location } from '#/graphql/types';
import { createLocation } from '#/graphql/mutations';
import { createMutationFields } from '../utils/mutationDataFields';
import { inUseStatuses } from '../utils/constants';

const q = gql(createLocation);

const useLocationCreate = () => {
  const [mutation, result] = useMutation<CreateLocationMutation>(q);
  const createLocation = useCallback(
    async (location: Location) => {
      const response = await mutation({
        variables: {
          data: {
            ...pick(location, createMutationFields),
            inUseStatus: inUseStatuses.newlyCreated.key,
          },
        },
      });
      return get(response, 'data.createLocation', undefined);
    },
    [mutation],
  );

  return { createLocation, result };
};

export default useLocationCreate;
